export class LockHandle {
    private readonly releaseCallback: () => void;

    public constructor(releaseCallback: () => void) {
        this.releaseCallback = releaseCallback;
    }

    public release(): void {
        this.releaseCallback();
    }
}
